// extracted by mini-css-extract-plugin
module.exports = {"pageNavigation":"_2_gjV-cazbyZfB_7Ctjof7"};